import React from 'react';
import { Svg } from '../Svg/Svg';
import PropTypes from 'prop-types';

export const Button = ({ primary, backgroundColor, label, disabled, icon, iconBefore, iconAfter, svg_className, colour, rotation, size, svg_list, ...props }) => {
    const mode = primary ? 'mz-btn--primary' : 'mz-btn--secondary';
    const disabling = disabled ? true : false;
    const before = iconBefore ? true : false;
    const after = iconAfter ? true : false;
    const displayIcon = icon ? true : false;
    // const iconBtn = icon ? true : false;
    //mz-link-icon-positon--right
    
    const btnBackground = backgroundColor != undefined ? `mz-btn--${backgroundColor}` : null ;
        return (
            <button
                type="button"
                className={['mz-btn', btnBackground, mode].join(' ')}
                disabled={disabling}

                {...props}
            >   
                <span className={displayIcon && before ? 'mz-link-icon-positon--left' :  displayIcon && after ? 'mz-link-icon-positon--right': null}>
                    {displayIcon && before 
                        ? <Svg  
                            colour={colour}
                            rotation={rotation}
                            size={size}
                            svg_list={svg_list}
                        /> : ''}
                    {label}
                    {displayIcon && after 
                        ? <Svg  
                            colour={colour}
                            rotation={rotation}
                            size={size}
                            svg_list={svg_list}
                        /> : ''}
                </span>
                
            </button>
        );
};

Button.propTypes = {
    primary: PropTypes.bool,
    backgroundColor: PropTypes.string,
    icon: PropTypes.bool,
    iconBefore: PropTypes.bool,
    iconAfter: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    colour: PropTypes.string,
    size: PropTypes.number,
    svg_list: PropTypes.string,
};
    
Button.defaultProps = {
    backgroundColor: null,
    icon: false,
    iconBefore: false,
    iconAfter: false,
    primary: true,
    onClick: undefined,
    disabled: false,
};
    
    
export default Button;